export enum UserType {
    all = 'all',
    people = 'people',
    thing = 'things',
}

export enum EUserFilterOption {
    name= 'name',
    category = 'category_name',
    san_id = 'san_id'
}

export enum FeatureWidget {
    indoor = 'indoor',
    outdoor = 'outdoor',
    user_search = 'user_search'
}

export enum EWidgetType {
    user_setting = 'user',
    unit_setting = 'unit',
  }
